<template>
  <div class="upcomingEvents">
    <div v-if="events.length" class="upcomingEvents-eventList">
      <EventRow
        v-for="event in events"
        :key="eventKey(event)"
        :event="event"
        :current-event="currentEvent"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import EventRow from './EventRow.vue'

export default {
  components: { EventRow },
  filters: {
    shortTime(string) {
      return dayjs(string).format('HH:mm')
    }
  },
  props: {
    events: { type: Array, required: true },
    currentEvent: { type: Object, default: null }
  },
  methods: {
    eventKey(event) {
      return event.date + ' ' + event.name
    },
    duration(event) {
      const now = dayjs()
      const end = dayjs(event.date).add(event.duration, 'minute')

      if (event === this.currentEvent) {
        return end.diff(now, 'm') + 'm left'
      } else {
        return event.duration + 'm'
      }
    },
    eventClasses(event) {
      return {
        event: true,
        'event-isCurrent': event === this.currentEvent,
        'event-isHighlighted': event.injectedEvent
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upcomingEvents-eventList {
  .eventRow:not(:last-child) {
    margin-bottom: 0.4em;
  }
}
</style>
